import { render } from "./puzzleCaptcha.vue?vue&type=template&id=7bc61380&scoped=true"
import script from "./puzzleCaptcha.vue?vue&type=script&lang=js"
export * from "./puzzleCaptcha.vue?vue&type=script&lang=js"

import "./puzzleCaptcha.vue?vue&type=style&index=0&id=7bc61380&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bc61380"]])

export default __exports__